import { render, staticRenderFns } from "./CAPTCHA.vue?vue&type=template&id=63f51d4c"
import script from "./CAPTCHA.vue?vue&type=script&lang=js"
export * from "./CAPTCHA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports